export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_03.7d7230e4.png";